import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';

export class SmsModel {
  smsForm = new UntypedFormGroup({
    'mobile': new UntypedFormControl(''),
    'tag': new UntypedFormControl('', [
      Validators.required,
    ]),
    'template': new UntypedFormControl('', [
      Validators.required,
    ]),
    'message': new UntypedFormControl('', [
      Validators.required,
    ])
  });
}
